import React from 'react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <a href="#home" className="text-xl font-bold text-cyan-400">
            Wrap A Lot Specialty Filmz
          </a>

          {/* Copyright */}
          <p className="text-gray-500 text-sm text-center">
            © {currentYear} WrapAlot Specialty Filmz. All rights reserved.
          </p>

          {/* Contact */}
          <a 
            href={`tel:${contactInfo.phone}`}
            className="text-gray-400 hover:text-cyan-400 transition-colors"
          >
            {contactInfo.phone}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
